import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const close = () => setOpen(false);

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <Link to="/" className="navbar-brand" onClick={close}>
          <img src="/logo.png" alt="Golden Gateway" style={{ height: 44, width: "auto", display: "block", flexShrink: 0 }} />
          <div>
            <div className="navbar-name">Golden Gateway</div>
            <div className="navbar-tagline">International Agency</div>
          </div>
        </Link>

        {/* Desktop links */}
        <div className="navbar-links navbar-desktop">
          <Link to="/">Home</Link>
          <Link to="/requirements">Requirements</Link>
          <Link to="/apply">Request Endorsement</Link>
          <Link to="/track">Track Endorsement</Link>
          <Link to="/admin/login" className="btn btn-outline" style={{ color: "var(--cream)", borderColor: "var(--gold-400)" }}>
            <i className="ti ti-user-shield"></i> Admin
          </Link>
        </div>

        {/* Hamburger button — mobile only */}
        <button className="navbar-hamburger" onClick={() => setOpen(!open)} aria-label="Menu">
          <i className={`ti ${open ? "ti-x" : "ti-menu-2"}`}></i>
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <>
          <div className="navbar-overlay" onClick={close} />
          <div className="navbar-drawer">
            <Link to="/" className="navbar-drawer-item" onClick={close}><i className="ti ti-home"></i> Home</Link>
            <Link to="/requirements" className="navbar-drawer-item" onClick={close}><i className="ti ti-list-details"></i> Requirements</Link>
            <Link to="/apply" className="navbar-drawer-item" onClick={close}><i className="ti ti-file-plus"></i> Request Endorsement</Link>
            <Link to="/track" className="navbar-drawer-item" onClick={close}><i className="ti ti-search"></i> Track Endorsement</Link>
            <div style={{ padding: "12px 20px" }}>
              <Link to="/admin/login" className="btn btn-outline" style={{ color: "var(--cream)", borderColor: "var(--gold-400)", width: "100%", justifyContent: "center" }} onClick={close}>
                <i className="ti ti-user-shield"></i> Admin Login
              </Link>
            </div>
          </div>
        </>
      )}
    </nav>
  );
}
